import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Injectable, Renderer2, RendererFactory2,ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { BehaviorSubject } from 'rxjs';
import { HomeService } from 'src/app/shared/services/home.service';
import { RepoApiService } from './repo-api.service';
import { ReportService } from './report.service';
import { ToplineService } from './topline.service';
import { SidePanelService } from 'src/app/shared/services/side-pannel/side-pannel.service';
import { MatDialog } from '@angular/material/dialog';
import { KpiGridRowNameEditComponent } from '../excel-viewer/table-view/kpi-grid-row-name-edit/kpi-grid-row-name-edit.component';
import { RemoveTopcutComponent } from '../excel-viewer/table-view/remove-topcut/remove-topcut.component';

@Injectable({
  providedIn: 'root'
})
export class ExcelViewerService {
  public isLoading:boolean = false;
  public inProgress:boolean = false;
  private renderer: Renderer2;
  public excelJson:any;
  public allFilters:any;
  public allFiltersForMerge:any;
  public kpiGridComponent:any;
  public allSheetsName:string[] = [];
  public all_Sheet_Name_only:string[] = [];
  public allSheetsNameForMerge:string[] = [];
  public excelParshedData:any;
  public selectedSheet:any = {};
  public selectedSheetReorderedKpis:any = {};
  public selectedSheetName:string = "";
  public counter = 0;
  public fileUUID = '';
  public trackerSessionId = 0;
  public studyName = '';
  public selectedFilter:any = {}
  public selectedKpis:any = {}
  public excelDataSUb: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public excelDataSUb1: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public studyUUID = null;
  public dataTableToplineMap:any = {}
  public isdataTableToplineMapFound:boolean = false;
  public editTableName:string = ""
  public topcutTreeArray:any [] = [];
  public isSheetnameEdit:boolean = false;
  public currentSheetTopcuts:any [] = [];
  public isSheetEditComponent:boolean = false;
  public isDownloadSettingComponent:boolean = false;
  public isToplineGroupTableComponent:boolean = false;
  public isEditGroupToplineComponent:boolean = false;
  public isDataSourceToplineComponent:boolean = false;
  public isMergeToplineComponent:boolean = false;
  public isKpiReorder:boolean = false;
  public currentSheetEditName:any = "";
  public downloadSetting:any = {};
  public duplicatedownloadSetting:any = {};
  public accessRoles:any;
  public disableOpenKpiDownload:boolean = true
  public disableOpenTabDownload:boolean = true
  public currentTableId:number = null;
  public currentGroupId:number = null;
  public hasFilters:boolean  = false
  public isResetPriorityneeded:boolean = false;
  public lastKpi:any = {};
  public movies:string[] = [];
  public defaultGroupOpenContainer:any[] = [
    'row-toggle-icon37360',
    'row-toggle-icon37222',
    'row-toggle-icon37223',
    'row-toggle-icon37224',
    'row-toggle-icon37225'
  ];
  public kpiParentId:string[] = [];
  public kpiParentIdStr:string = "";
  public isExcelOPenKPIS:boolean = true;
  public selectedKpiReorder:any = {};
  public editGroupToplineDetails:any = {};
  public currentOpeningSheetIndex:number = 0;
  public prevHoverElement:any = {};
  public custom_operators:any[] = [];
  public topcutdataTreeJSONForMerge:any = [];
  public table_definition : any = {"topcut":[],"table":[]};
  public kpiViewerMerge:any [] = [];
  public kpiGridEditRowNameEventContainer:any
  public selectedKpiDetails:any;
   public kpiRows:any[] = [];
  public kpiKey:string = ""
  public selectedKpi:any = {};
  public kpi:any;
  public openKpiAgGridTab:any;
  public applyChangeForEditRowName:string = "onlyTable";
  public topCutLevelContainer:any = {};
  public topcutRemoveType:string = "";

//   public isMergeFileContainAllSheets:boolean = true;
//   public topcutdataTreeJSONForMerge:any = [];



  constructor(private notifier:NotifierService, 
    private router:Router,
    private repoService:RepoApiService,
    public reportService:ReportService,
    public toplineService:ToplineService,
    rendererFactory: RendererFactory2,
    public homeService: HomeService,
    private sidePanelService:SidePanelService,
    public dialog:MatDialog,
    ) {
    this.excelDataSUb.subscribe((value) => {  });
    this.excelDataSUb1.subscribe((value) => {  });
    this.renderer = rendererFactory.createRenderer(null, null);
    
  }

  selectSheet(sheet, options?:any){
    // console.log('sheet : ', sheet);
    if (!(options && options.isRefresh)) {
      this.setCurrentTableId(null)
    }
    this.closeAllTabs();
    this.setdDisableOpenKpiDownload(true);
    this.selectedSheet = sheet;
    this.isSheetnameEdit = false;
    // console.log("this.selectedSheet 1 ===>",this.selectedSheet)
    this.isToplineGroupTableComponent = false;
    this.isMergeToplineComponent = false;
    this.selectedSheet["value"]["name"] = sheet.key
    this.excelJson = null;
    this.selectedFilter = {};
    this.selectedKpis = {}
    // this.excelDataSUb.next(true);
    this.closeKPIReorder();
    this.checkHasFilters();
    this.getExcelData();
  }

  selectBlankSheet(sheet){
    this.setdDisableOpenKpiDownload(true);
    this.setdDisableOpenTabDownload(!(sheet["value"] && sheet["value"]["kpis"] && Object.keys(sheet["value"]["kpis"]).length > 0))
    this.closeAllTabs();
    this.selectedSheet = sheet;
    this.isSheetnameEdit = false;
    // console.log("this.selectedSheet b ===>",this.selectedSheet)
    this.isToplineGroupTableComponent = false;
    this.selectedSheet["value"]["name"] = sheet.key;
    this.selectedSheet["value"]["sheet_name"] = sheet.key;
    this.closeKPIReorder();
    this.checkHasFilters();
    this.resetTableView();
    this.lastKpi = null
    // let tableRef = document.getElementById('tableID') as HTMLElement;
    // if (tableRef) {
    //   this.renderer.setProperty(tableRef, 'innerHTML','');
    // }
    this.excelDataSUb.next(true);
  }

  resetTableView(){
    let tableRef = document.getElementById('tableID') as HTMLElement;
    if (tableRef) {
      this.renderer.setProperty(tableRef, 'innerHTML','');
    }
  }
  
  getExcelData(){
    this.isLoading = true;
    this.inProgress = false;
    let data = {};
    data['uuid'] = this.fileUUID;
    this.homeService.isOpen = false;
    if(this.selectedSheet && this.selectedSheet['key']){
      data['tab'] = this.selectedSheet['key'];
      data['tab_id'] = this.selectedSheet['value']["sheet_id"];
      data['data'] = {}
      if (Object.keys(this.selectedFilter).length) {
        data['data']['filters'] = this.selectedFilter;
      }
      if (Object.keys(this.selectedKpis).length) {
        data['data']['kpis'] = this.selectedKpis;
      }
    }
    this.excelJson = null;
    this.repoService.getExcelData(data).subscribe(result => {
      this.isLoading = false;
      if(result['status'] == 1){
        this.excelJson = result['result'];
        // this.custom_operators = result['custom_operators'];
        let defaultSheet = {"key":"","value":{}};
        if(this.selectedSheet && this.selectedSheet['key']){
          defaultSheet['key'] = this.selectedSheet['key'];
          defaultSheet['value'] = result['result'][this.selectedSheet['key']];
        }else{
          defaultSheet['key'] = Object.keys(result['result'])[0];
          defaultSheet['value'] = result['result'][Object.keys(result['result'])[0]];
        }
        defaultSheet["value"]["name"] = defaultSheet["key"]
        this.selectedSheet = defaultSheet;
        this.setLastKpi()
        this.setdDisableOpenTabDownload(!(defaultSheet["value"]["kpis"] && Object.keys(defaultSheet["value"]["kpis"]).length > 0));
        this.excelDataSUb.next(true);
        this.excelDataSUb1.next(true);
      }else if(result['status'] == 3){
        this.inProgress = true;
      }else if(result['status'] == 4){
        this.notifier.notify('error',result['message']);
        this.sidePanelService.afterLoginNavigate();
      }else{
        this.notifier.notify('error','Something went wrong!');
      }
    }, error => {
      this.isLoading = false;
      this.notifier.notify('error','Something went wrong!');
    });
  }

  getSheetPayload(){
    this.currentSheetTopcuts = []
    this.selectedSheet.value["payload"] = {};
    if (this.selectedSheet.value && this.selectedSheet.value["kpis"] && Object.keys(this.selectedSheet.value["kpis"]).length) {
      this.selectedSheet.value["payload"] = this.selectedSheet.value["kpis"][Object.keys(this.selectedSheet.value["kpis"])[0]]["payload"];
      this.parseSelectedSheetTopcuts();
    }
  }

  setdDisableOpenKpiDownload(status:boolean){
    this.disableOpenKpiDownload = status
  }

  setdDisableOpenTabDownload(status:boolean){
    this.disableOpenTabDownload = status
  }

  setCurrentTableId(id){
    this.currentTableId = id ? id :null;
  }

  setCurrentGroupId(id){
    this.currentGroupId = id ? id :null;
  }

  getOriginalSheetNames(sheetObj){
    let originalSheetNames = [];
    Object.keys(sheetObj).forEach(sheetKey => {
        originalSheetNames.push(sheetObj[sheetKey]["sheet_name"])
    });
    return originalSheetNames;
  }

  getFilterOptions(){
    let data = {"uuid":this.fileUUID};
    this.isLoading = true;
    this.repoService.getFilterOptions(data).subscribe(result => {
      if(result['status'] == 1){
        this.allSheetsName = []
        this.all_Sheet_Name_only = []
        this.allFilters = result['result'];
        this.custom_operators = result['custom_operators'];
        console.log(this.custom_operators,'custom_operators');
        this.studyName =  result['studyName'];
        this.reportService.fileUUID = result['uuid'];
        this.trackerSessionId = result['session_id'];
        this.studyUUID = result['studyId'];
        this.allSheetsName = Object.keys(this.allFilters);
        this.all_Sheet_Name_only = this.getOriginalSheetNames(this.allFilters)
        this.isdataTableToplineMapFound = false;
        this.isLoading = false;
        this.downloadSetting = Object.keys(result['settings']).length ? result['settings'] : {download:{headers:'common',theme_id:1}};
        this.duplicatedownloadSetting = Object.keys(result['settings']).length ? result['settings'] : {download:{headers:'common',theme_id:1}}
        if (result["data_table_obj"]) {
          this.getToplineCrosstabData(result["data_table_obj"])
        }
        if (Object.keys(this.allFilters).length) {
          this.currentOpeningSheetIndex = 0;
          this.selectSheet({'key':Object.keys(this.allFilters)[0],'value':this.allFilters[Object.keys(this.allFilters)[0]]})
        }
      }else if(result['status'] == 2){
        this.allFilters = {"sheet-1":{"filters":{},"kpis":{},"text": [], "sheet_name":"sheet-1","isNewSheet":true}}
        this.custom_operators = result['custom_operators'];
        this.allSheetsName = Object.keys(this.allFilters);
        this.all_Sheet_Name_only = this.getOriginalSheetNames(this.allFilters)
        this.isLoading = false;
        this.inProgress = false;
        this.selectBlankSheet({'key':Object.keys(this.allFilters)[0],'value':this.allFilters[Object.keys(this.allFilters)[0]]})
        this.getToplineCrosstabData(result["data_table_obj"]);
      }else if(result['status'] == 3){
        this.isLoading = false;
        this.excelJson = null;
        this.inProgress = true;
      }else if(result['status'] == 4){
        this.notifier.notify('error',result['message']);
        this.sidePanelService.afterLoginNavigate();
      }else{
        this.isdataTableToplineMapFound = false;
        this.notifier.notify('error','Something went wrong');
        this.isLoading = false;
      }
    }, error => {
      this.notifier.notify('error','Something went wrong');
      this.isLoading = false;
    });
  }


  getFilterOptionsForMerge(id:any){
    let data = {"uuid":id};
    this.isLoading = true;
    this.repoService.getFilterOptions(data).subscribe(result => {
      if(result['status'] == 1){
        this.allFiltersForMerge = result['result'];
        this.allSheetsNameForMerge = Object.keys(this.allFiltersForMerge);
        this.getTopCutBasedOnSelectedSheetForMerge(this.allSheetsNameForMerge[0]);
        // this.checkforSameSheets();
        this.isLoading = false;
      }
    }, error => {
      this.notifier.notify('error','Something went wrong');
      this.isLoading = false;
    });
  }

  


  getTopCutBasedOnSelectedSheetForMerge(sheetName){
    this.topcutdataTreeJSONForMerge = [];
    this.createTopcutForMerge(this.allFiltersForMerge[sheetName]['filters']);
  }

  createTopcutForMerge(topcutObj){
    let newtopcutObj = [];
    newtopcutObj= [{"Select All":{'type':'option',"sType":"All","name":"Select All"}}];
    Object.keys(topcutObj).forEach((key) =>{
      let temp = {};
      temp[key] = topcutObj[key]
      newtopcutObj.push(temp)
    })
    newtopcutObj.forEach(cut => {
      this.recurciveTopCutTreeObjForMerge(cut,'root','root','0-',this.topcutdataTreeJSONForMerge)
    })
    setTimeout(() =>{
        let treeArray = this.process(this.topcutdataTreeJSONForMerge)
        let treeObj = treeArray[0];
        treeObj['children'] = [];
        treeArray.forEach((item, index) => {
          if (index > 0) {
            treeObj['children'].push(item);
          }
        });
        this.topcutdataTreeJSONForMerge = [];
        this.topcutdataTreeJSONForMerge.push(treeObj);
    },100);
  }

//   recurciveTreeObj(topcut, parent, id, allowed_topcuts, treeJson){
//     Object.keys(topcut).forEach((key, index)=>{
//       let dataItem = {};
//       dataItem['id'] = id + '' + parent + '---' + key;
//       dataItem['name'] = key;
//       dataItem['parent'] = parent;
//       dataItem['p'] = '';
//       dataItem['show'] = false;
//       dataItem['n'] = topcut[key]['n'];
//       dataItem['dindex'] = "";

//       if (topcut[key]["dindex"] >=0) {
//         dataItem['dindex'] = topcut[key]["dindex"];
//         // console.log(typeof(topcut[key]["dindex"]))
//       }
//       if (topcut[key]['sType'] && topcut[key]['sType'] == 'All') {
//         dataItem['sType'] = 'All'; 
//       }
//       if (parent.split('---').length > 1) {
//         dataItem['p'] = parent.split('---')[1];
//       }else{
//         dataItem['p'] = key;
//       }
//       if(topcut[key]['type'] == 'level'){
//         dataItem['children'] = [];
//         treeJson.push(dataItem);
//         if (dataItem['sType'] == 'All') {
//           this.recurciveTreeObj(topcut[key]['options'], parent, id, allowed_topcuts, dataItem['children']);
//         }else{
//           this.recurciveTreeObj(topcut[key]['options'], parent+'---'+key, id, allowed_topcuts, dataItem['children']);
//         }
//       }else{
//         treeJson.push(dataItem);
//       }
//     });
//   }


recurciveTopCutTreeObjForMerge(topcut, parent, parentName, id, treeJson){
  Object.keys(topcut).forEach((key, index)=>{
      let dataItem = {};
      let cutName = topcut[key]["name"];
      let parentId = parent;
      dataItem['p'] = '';
      if (parentName.split('---').length > 1) {
        dataItem['p'] = parentName.split('---')[1];
        parentId = parentId + "$$$" + parentName;
      }else{
        dataItem['p'] = cutName;
      }
      dataItem['id'] = id + '' + parentId + '---' + key + "$$$" + cutName;
      // dataItem['id'] = id + '' + parent + '---' + key;
      dataItem['name'] = cutName;
      dataItem['uuid'] = key;
      dataItem['parent'] = parent;
      dataItem['parentName'] = parentName;
      dataItem['show'] = false;
      dataItem['n'] = topcut[key]['n'];
      if (topcut[key]['sType'] && topcut[key]['sType'] == 'All') {
        dataItem['sType'] = 'All'; 
      }
      if(topcut[key]['type'] == 'level'){
        dataItem['children'] = [];
        treeJson.push(dataItem);
        if (dataItem['sType'] == 'All') {
          this.recurciveTopCutTreeObjForMerge(topcut[key]['options'], parent, parentName, id, dataItem['children']);
        }else{
          this.recurciveTopCutTreeObjForMerge(topcut[key]['options'], parent+'---'+key, parentName+'---'+cutName, id,dataItem['children']);
        }
      }else{
        treeJson.push(dataItem);
      }
  });
}

  
  private process(data): any {
    let result = [];
    result = data.map((item) => {
      return this.toTreeNode(item);
    });
    return result;
  }

  private toTreeNode(node, parent = null) {
    // console.log(node, parent);
    if(node && node.children) {
      node.children.map(item => {
        return this.toTreeNode(item, node);
      });
    }
    
    return node;
  }

 



  refreshFilterOptions(sheet_id?:number){
    let data = {"uuid":this.fileUUID};
    this.isLoading = true;
    this.repoService.getFilterOptions(data).subscribe(result => {
      if(result['status'] == 1){
        this.allSheetsName = []
        this.allFilters = result['result'];
        this.allSheetsName = Object.keys(this.allFilters);
        this.all_Sheet_Name_only = this.getOriginalSheetNames(this.allFilters)
        // let selectedSheet = {};
        Object.keys(this.allFilters).forEach((sheetKey,index) => {
          if (sheet_id) {
            if (this.allFilters[sheetKey].sheet_id == sheet_id) {
              this.selectedSheet["key"] = sheetKey;
              this.selectedSheet["value"] = this.allFilters[sheetKey];
              this.currentOpeningSheetIndex = index;
            }
          }else{
            if (this.allFilters[sheetKey].sheet_id == this.selectedSheet["value"]["sheet_id"]) {
              this.selectedSheet["key"] = sheetKey;
              this.selectedSheet["value"] = this.allFilters[sheetKey];
            }
          }
        });
        this.isLoading = false;
        this.selectSheet({'key':this.selectedSheet.key,'value':this.allFilters[this.selectedSheet.key]},{"isRefresh":true})
        // if (Object.keys(this.allFilters).length) {
        //   this.selectSheet({'key':Object.keys(this.allFilters)[0],'value':this.allFilters[Object.keys(this.allFilters)[0]]})
        // }
      }
      else if(result['status'] == 2){
        this.allFilters = {"sheet-1":{"filters":{},"kpis":{},"text": [], "sheet_name":"sheet-1","isNewSheet":true}}
        this.allSheetsName = Object.keys(this.allFilters);
        this.all_Sheet_Name_only = this.getOriginalSheetNames(this.allFilters)
        this.selectBlankSheet({'key':Object.keys(this.allFilters)[0],'value':this.allFilters[Object.keys(this.allFilters)[0]]})
        this.getToplineCrosstabData(result["data_table_obj"])
      }else if(result['status'] == 4){
        this.notifier.notify('error',result['message']);
        this.sidePanelService.afterLoginNavigate();
        // this.isLoading = false;
      }else{
        this.notifier.notify('error','Something went wrong');
        this.isLoading = false;
      }
    }, error => {
      this.notifier.notify('error','Something went wrong!');
      this.isLoading = false;
    });
  }

  checkHasFilters(){
    this.hasFilters = this.selectedSheet && this.selectedSheet['value'] && this.selectedSheet['value']['filters'] && Object.keys(this.selectedSheet['value']['filters']).length ? true :false;
    // this.hasFilters = this.allFilters && this.allFilters[this.selectedSheet['key']] && this.allFilters[this.selectedSheet['key']]['filters'] && Object.keys(this.allFilters[this.selectedSheet['key']]['filters']).length ? true :false;
  }

  getToplineCrosstabData(data_table_obj){
    this.isdataTableToplineMapFound = true;
    this.dataTableToplineMap = data_table_obj
    this.toplineService.setExcelviewerFileUUID(this.fileUUID)
    this.toplineService.setCrosstabFileUUID(data_table_obj.uuid)
    this.reportService.getRepositoryDetailByFile(this.fileUUID,{createTopline:true,crossTabId:data_table_obj.uuid});
    // this.reportService.getRepositoryDetailByFile(data_table_obj.uuid,{createTopline:true});
    // setTimeout(() => {
    //   this.toplineService.openToplineParameter();
    // }, 100);
  }

  addNewSheet(){
    let index = Object.keys(this.allFilters).length +1;
    let newSheetName = this.getSheetName(index);
    this.removekpiViewerMerge();
    this.allFilters[newSheetName] = {"filters":{},"kpis":{},"text": [],"isNewSheet":true, "sheet_name":newSheetName};
    // this.allFilters["sheet-"+index] = {"filters":{},"kpis":{},"text": [],"isNewSheet":true};
    this.allSheetsName = Object.keys(this.allFilters);
    this.all_Sheet_Name_only = this.getOriginalSheetNames(this.allFilters)
    this.selectBlankSheet({"key":newSheetName,"value":{}})
    // this.selectBlankSheet({"key":"sheet-"+index,"value":{}})
  }

  getSheetName(index){
    let sheetNameFound = Object.keys(this.allFilters).find(item => item === "sheet-"+index);
    if (sheetNameFound !=undefined && sheetNameFound != "") {
      return this.getSheetName(index + 1)
    }else{
      return "sheet-"+index;
    }
  }


  // resetKpiPriorities(kpiList){
  //   this.isResetPriorityneeded = false;
  //   let kpiPriorityList = [];
  //   Object.keys(kpiList).forEach((kpiKey,index) => {
  //     kpiPriorityList.push({id :kpiList[kpiKey].kpi_id, name: kpiKey, priority:index})
  //   });
  //   let body = {
  //     data : kpiPriorityList,
  //     sheet_id: this.selectedSheet.value["sheet_id"]
  //   }
  //   this.repoService.setKpiPriority(body).subscribe(
  //     result=>{
  //       if (result["status"] == 1) {
  //         // this.refreshFilterOptions();
  //         this.isLoading = false;
  //       }else{
  //         this.notifier.notify("error",result["message"]);
  //         this.isLoading = false;
  //       }
  //     }, error =>{
  //       console.log(error);
  //       this.isLoading = false;
  //     }
  //   )
  // }

  deleteTable(tableData:any){
    // this.isResetPriorityneeded = false;
    // if (tableData && tableData.parent_id && tableData.parent_id.split("$_$-$_$").length < 3) {
    //   this.isResetPriorityneeded = true;
    // }
    this.isLoading = true;
    this.kpiParentId = [];
    this.repoService.deleteTopline(tableData).subscribe(
      result=>{
        if (result["status"] == 1) {
          this.notifier.notify("success","Table deleted successfully");
          let parent_id = result["parent_id"];
          this.kpiParentId = parent_id.split("$_$-$_$");
          this.resetDatatableToplineUtilities();
          // if (this.isResetPriorityneeded) {
          //   this.resetKpiPriorities(this.selectedSheet['value']['kpis'])
          // }else{
          // }
          this.refreshFilterOptions();
          this.isLoading = false;
        }else{
          this.notifier.notify("error","Something went wrong!");
          this.isLoading = false;
        }
      }, error =>{
        console.log(error);
        this.isLoading = false;
      }
    )
  }

  deleteGroup(tableData:any){
    // this.isResetPriorityneeded= false;
    // if (tableData && tableData.parent_id && tableData.parent_id.split("$_$-$_$").length < 3) {
    //   this.isResetPriorityneeded = true
    // }
    this.isLoading = true;
    this.repoService.deleteGroupInTopline(tableData).subscribe(
      result=>{
        if (result["status"] == 1) {
          this.notifier.notify("success","Group deleted successfully");
          let parent_id = result["parent_id"];
          this.resetDatatableToplineUtilities();
          // if (this.isResetPriorityneeded) {
          //   this.resetKpiPriorities(this.selectedSheet['value']['kpis'])
          // }else{
          // }
          this.refreshFilterOptions();
          this.isLoading = false;
        }else{
          this.notifier.notify("error","Something went wrong!");
          this.isLoading = false;
        }
      }, error =>{
        console.log(error);
        this.isLoading = false;
      }
    )
  }


  setPayloadForKpiMerge(body){
    this.isLoading = true;
    this.repoService.mergeKpiFile(body).subscribe((res) =>{
        if(res['status'] == 1){
          this.isMergeToplineComponent = false;      
          this.notifier.notify("success","Kpi merge successfully");
          // this.getFilterOptions();
          this.refreshFilterOptions();
        }else{
            this.notifier.notify("error","Something went wrong!");
            this.isLoading = false;
        }
    })
  }

  
  copyTable(tableData:any){
    this.isLoading = true;
    this.kpiParentId = [];
    this.repoService.copyTopline(tableData).subscribe(
      result=>{
        if (result["status"] == 1) {
          this.notifier.notify("success","Table copied successfully");
          this.resetDatatableToplineUtilities();
          // this.setCurrentTableId(result["id"])
          if (Number(result["id"])) {
            this.setCurrentTableId(Number(result["id"]))
          }else{
            this.setCurrentTableId(null)
          }
          let parent_id = result["parent_id"];
          this.kpiParentId = parent_id.split("$_$-$_$");
          this.refreshFilterOptions();
          this.isLoading = false;
        }else{
          this.notifier.notify("error","Something went wrong!");
          this.isLoading = false;
        }
      }, error =>{
        console.log(error);
        this.isLoading = false;
      }
    )
  }


  copyGroup(groupData:any){
    // console.log(groupData,'groupData');
    this.isLoading = true;
    this.kpiParentId = [];
    this.repoService.copyGroupInTopline(groupData).subscribe(
      result=>{
        if (result["status"] == 1) {
          this.notifier.notify("success","Group copied successfully");
          this.resetDatatableToplineUtilities();
          this.isExcelOPenKPIS = false;
          // this.setCurrentGroupId(result["id"])
          if (Number(result["id"])) {
            this.setCurrentGroupId(Number(result["id"]))
          }else{
            this.setCurrentGroupId(null)
          }
          let parent_id = result["parent_id"];
          this.kpiParentId = parent_id.split("$_$-$_$");
          this.refreshFilterOptions();
          this.isLoading = false;
        }else{
          this.notifier.notify("error","Something went wrong!");
          this.isLoading = false;
        }
      }, error =>{
        console.log(error);
        this.isLoading = false;
      }
    )
  }

  setLastKpi(){
    if (this.selectedSheet["value"]["kpis"] && Object.keys(this.selectedSheet["value"]["kpis"]).length) {
      let lastIndex = Object.keys(this.selectedSheet["value"]["kpis"]).length - 1;
      let kpiKeys = Object.keys(this.selectedSheet["value"]["kpis"])
      this.lastKpi = this.selectedSheet["value"]["kpis"][kpiKeys[lastIndex]]
    }else{
      this.lastKpi = null;
    }
    
  }

  createTable(){
    this.toplineService.createTable()
  }

//   dummyEditTable(){
//     let savedTable = {
//         "cross_tab_id": "9b7675d0-8329-4577-915e-531a21e3be56",
//         "file_id": "0ca43988-d608-4962-a659-1e8ae0d90e20",
//         "parent_id": "",
//         "payload": {
//             "t1": {
//                 "selected_tables": [
//                     "14405607-7d47-4834-932c-ec220f98815b",
//                     "33d4f6aa-e346-425a-9b55-d651b650d91a"
//                 ],
//                 "sidecut": {
//                     "value_type": "sidecut",
//                     "values": {
//                         "16925b20-d37e-4af8-a3ff-d098f7cb6243": {
//                             "allowed_topcuts": 6,
//                             "id": "6-root---14405607-7d47-4834-932c-ec220f98815b---16925b20-d37e-4af8-a3ff-d098f7cb6243$$$r2",
//                             "index": 2,
//                             "name": "r2",
//                             "p": "Table1",
//                             "parent": "root---14405607-7d47-4834-932c-ec220f98815b",
//                             "parent_uuid": "14405607-7d47-4834-932c-ec220f98815b",
//                             "priority": 2,
//                             "selectionOrder": 2,
//                             "show": false,
//                             "uuid": "16925b20-d37e-4af8-a3ff-d098f7cb6243"
//                         },
//                         "2cc038d8-68a7-4c25-98b0-0239cebc801d": {
//                             "allowed_topcuts": 8,
//                             "id": "8-root---33d4f6aa-e346-425a-9b55-d651b650d91a---2cc038d8-68a7-4c25-98b0-0239cebc801d$$$r1",
//                             "index": 3,
//                             "name": "r1",
//                             "p": "Table1",
//                             "parent": "root---33d4f6aa-e346-425a-9b55-d651b650d91a",
//                             "parent_uuid": "33d4f6aa-e346-425a-9b55-d651b650d91a",
//                             "priority": 3,
//                             "selectionOrder": 3,
//                             "show": false,
//                             "uuid": "2cc038d8-68a7-4c25-98b0-0239cebc801d"
//                         },
//                         "43321b03-b2ec-4873-884d-082ea17f96fd": {
//                             "allowed_topcuts": 6,
//                             "id": "6-root---14405607-7d47-4834-932c-ec220f98815b---43321b03-b2ec-4873-884d-082ea17f96fd$$$r1",
//                             "index": 1,
//                             "name": "r1",
//                             "p": "Table1",
//                             "parent": "root---14405607-7d47-4834-932c-ec220f98815b",
//                             "parent_uuid": "14405607-7d47-4834-932c-ec220f98815b",
//                             "priority": 1,
//                             "selectionOrder": 1,
//                             "show": false,
//                             "uuid": "43321b03-b2ec-4873-884d-082ea17f96fd"
//                         },
//                         "544ecf95-8549-4c78-9522-444a873d4cab": {
//                             "allowed_topcuts": 8,
//                             "id": "8-root---33d4f6aa-e346-425a-9b55-d651b650d91a---544ecf95-8549-4c78-9522-444a873d4cab$$$r2",
//                             "index": 4,
//                             "name": "r2",
//                             "p": "Table1",
//                             "parent": "root---33d4f6aa-e346-425a-9b55-d651b650d91a",
//                             "parent_uuid": "33d4f6aa-e346-425a-9b55-d651b650d91a",
//                             "priority": 4,
//                             "selectionOrder": 4,
//                             "show": false,
//                             "uuid": "544ecf95-8549-4c78-9522-444a873d4cab"
//                         }
//                     }
//                 },
//                 "topcut": {
//                     "value_type": "topcut",
//                     "values": {
//                         "c92f63f8-fa8d-4d27-8267-1392bc4fff67": {
//                             "options": {
//                                 "85bea24f-b18f-4f98-aa68-2e5509738a78": {
//                                     "options": {
//                                         "2dae89b1-d0c1-4107-8359-5fff5b79c2e7": {
//                                             "allowed_topcuts": 6,
//                                             "dindex": 4,
//                                             "id": "6-root---c92f63f8-fa8d-4d27-8267-1392bc4fff67---85bea24f-b18f-4f98-aa68-2e5509738a78---2dae89b1-d0c1-4107-8359-5fff5b79c2e7$$$Ch1",
//                                             "index": 4,
//                                             "name": "Ch1",
//                                             "p": "Col_L1",
//                                             "parent": "root---c92f63f8-fa8d-4d27-8267-1392bc4fff67---85bea24f-b18f-4f98-aa68-2e5509738a78",
//                                             "selectionOrder": 5,
//                                             "show": false,
//                                             "type": "option",
//                                             "uuid": "2dae89b1-d0c1-4107-8359-5fff5b79c2e7"
//                                         },
//                                         "5eb15eb0-486a-4bac-95a4-25fe7458544a": {
//                                             "allowed_topcuts": 6,
//                                             "dindex": 5,
//                                             "id": "6-root---c92f63f8-fa8d-4d27-8267-1392bc4fff67---85bea24f-b18f-4f98-aa68-2e5509738a78---5eb15eb0-486a-4bac-95a4-25fe7458544a$$$Ch2",
//                                             "index": 5,
//                                             "name": "Ch2",
//                                             "p": "Col_L1",
//                                             "parent": "root---c92f63f8-fa8d-4d27-8267-1392bc4fff67---85bea24f-b18f-4f98-aa68-2e5509738a78",
//                                             "selectionOrder": 6,
//                                             "show": false,
//                                             "type": "option",
//                                             "uuid": "5eb15eb0-486a-4bac-95a4-25fe7458544a"
//                                         }
//                                     },
//                                     "type": "topcut"
//                                 },
//                                 "fa33575f-0db3-4583-a18d-31450fa19437": {
//                                     "options": {
//                                         "25b43e8a-f942-48e1-91ee-7e1cee36d967": {
//                                             "allowed_topcuts": 6,
//                                             "dindex": 6,
//                                             "id": "6-root---c92f63f8-fa8d-4d27-8267-1392bc4fff67---fa33575f-0db3-4583-a18d-31450fa19437---25b43e8a-f942-48e1-91ee-7e1cee36d967$$$Ch1",
//                                             "index": 6,
//                                             "name": "Ch1",
//                                             "p": "Col_L1",
//                                             "parent": "root---c92f63f8-fa8d-4d27-8267-1392bc4fff67---fa33575f-0db3-4583-a18d-31450fa19437",
//                                             "selectionOrder": 7,
//                                             "show": false,
//                                             "type": "option",
//                                             "uuid": "25b43e8a-f942-48e1-91ee-7e1cee36d967"
//                                         },
//                                         "9216a58b-5a18-40a0-9ba0-61e51204d8b6": {
//                                             "allowed_topcuts": 6,
//                                             "dindex": 7,
//                                             "id": "6-root---c92f63f8-fa8d-4d27-8267-1392bc4fff67---fa33575f-0db3-4583-a18d-31450fa19437---9216a58b-5a18-40a0-9ba0-61e51204d8b6$$$Ch2",
//                                             "index": 7,
//                                             "name": "Ch2",
//                                             "p": "Col_L1",
//                                             "parent": "root---c92f63f8-fa8d-4d27-8267-1392bc4fff67---fa33575f-0db3-4583-a18d-31450fa19437",
//                                             "selectionOrder": 8,
//                                             "show": false,
//                                             "type": "option",
//                                             "uuid": "9216a58b-5a18-40a0-9ba0-61e51204d8b6"
//                                         }
//                                     },
//                                     "type": "topcut"
//                                 }
//                             },
//                             "type": "topcut"
//                         },
//                         "cf0408f9-0c1e-437d-b668-e92f7e1f3625": {
//                             "options": {
//                                 "42ef3c4f-5449-4188-a9b2-b402b7557b7f": {
//                                     "options": {
//                                         "75bc5dea-fde2-40c7-8b73-b6f88c7c6e85": {
//                                             "allowed_topcuts": 6,
//                                             "dindex": 2,
//                                             "id": "6-root---cf0408f9-0c1e-437d-b668-e92f7e1f3625---42ef3c4f-5449-4188-a9b2-b402b7557b7f---75bc5dea-fde2-40c7-8b73-b6f88c7c6e85$$$Ch1",
//                                             "index": 2,
//                                             "name": "Ch1",
//                                             "p": "Col_L1",
//                                             "parent": "root---cf0408f9-0c1e-437d-b668-e92f7e1f3625---42ef3c4f-5449-4188-a9b2-b402b7557b7f",
//                                             "selectionOrder": 3,
//                                             "show": false,
//                                             "type": "option",
//                                             "uuid": "75bc5dea-fde2-40c7-8b73-b6f88c7c6e85"
//                                         },
//                                         "c19d7459-1756-4ee3-87f0-736c0c215b3a": {
//                                             "allowed_topcuts": 6,
//                                             "dindex": 3,
//                                             "id": "6-root---cf0408f9-0c1e-437d-b668-e92f7e1f3625---42ef3c4f-5449-4188-a9b2-b402b7557b7f---c19d7459-1756-4ee3-87f0-736c0c215b3a$$$Ch2",
//                                             "index": 3,
//                                             "name": "Ch2",
//                                             "p": "Col_L1",
//                                             "parent": "root---cf0408f9-0c1e-437d-b668-e92f7e1f3625---42ef3c4f-5449-4188-a9b2-b402b7557b7f",
//                                             "selectionOrder": 4,
//                                             "show": false,
//                                             "type": "option",
//                                             "uuid": "c19d7459-1756-4ee3-87f0-736c0c215b3a"
//                                         }
//                                     },
//                                     "type": "topcut"
//                                 },
//                                 "b512f7aa-0a0e-4797-9656-8c296e865354": {
//                                     "options": {
//                                         "39c6e3be-e17c-414b-8c45-0628ee1bbc85": {
//                                             "allowed_topcuts": 6,
//                                             "dindex": 0,
//                                             "id": "6-root---cf0408f9-0c1e-437d-b668-e92f7e1f3625---b512f7aa-0a0e-4797-9656-8c296e865354---39c6e3be-e17c-414b-8c45-0628ee1bbc85$$$Ch1",
//                                             "index": 0,
//                                             "name": "Ch1",
//                                             "p": "Col_L1",
//                                             "parent": "root---cf0408f9-0c1e-437d-b668-e92f7e1f3625---b512f7aa-0a0e-4797-9656-8c296e865354",
//                                             "selectionOrder": 1,
//                                             "show": false,
//                                             "type": "option",
//                                             "uuid": "39c6e3be-e17c-414b-8c45-0628ee1bbc85"
//                                         },
//                                         "f4a3a81c-a319-478e-9ee2-e2950c1edf38": {
//                                             "allowed_topcuts": 6,
//                                             "dindex": 1,
//                                             "id": "6-root---cf0408f9-0c1e-437d-b668-e92f7e1f3625---b512f7aa-0a0e-4797-9656-8c296e865354---f4a3a81c-a319-478e-9ee2-e2950c1edf38$$$Ch2",
//                                             "index": 1,
//                                             "name": "Ch2",
//                                             "p": "Col_L1",
//                                             "parent": "root---cf0408f9-0c1e-437d-b668-e92f7e1f3625---b512f7aa-0a0e-4797-9656-8c296e865354",
//                                             "selectionOrder": 2,
//                                             "show": false,
//                                             "type": "option",
//                                             "uuid": "f4a3a81c-a319-478e-9ee2-e2950c1edf38"
//                                         }
//                                     },
//                                     "type": "topcut"
//                                 }
//                             },
//                             "type": "topcut"
//                         }
//                     }
//                 },
//                 "values": {
//                     "value_type": "table",
//                     "values": {
//                         "14405607-7d47-4834-932c-ec220f98815b": {
//                             "allowed_topcuts": "0",
//                             "id": "0-root---14405607-7d47-4834-932c-ec220f98815b$$$Table1",
//                             "index": 1,
//                             "name": "Table1",
//                             "p": "Table1",
//                             "parent": "root",
//                             "parent_uuid": "14405607-7d47-4834-932c-ec220f98815b",
//                             "selectionOrder": 1,
//                             "show": false,
//                             "uuid": "14405607-7d47-4834-932c-ec220f98815b"
//                         },
//                         "33d4f6aa-e346-425a-9b55-d651b650d91a": {
//                             "allowed_topcuts": "0",
//                             "id": "0-root---33d4f6aa-e346-425a-9b55-d651b650d91a$$$Table1",
//                             "index": 2,
//                             "name": "Table1",
//                             "p": "Table1",
//                             "parent": "root",
//                             "parent_uuid": "33d4f6aa-e346-425a-9b55-d651b650d91a",
//                             "selectionOrder": 2,
//                             "show": false,
//                             "uuid": "33d4f6aa-e346-425a-9b55-d651b650d91a"
//                         }
//                     }
//                 }
//             }
//         },
//         "priority": 0,
//         "sheet_name": "sheet-1"
//     }
//     let tableData = {"tableName":"t1","table_id":"table_id","payload":savedTable.payload.t1,"parent_id":"parent_id","data":{}}
//     this.editTable(tableData)
//   }

  editTable(tableData:any){
    if (!tableData["payload"]) {
      this.notifier.notify("error","Unable to get this file !");
      return;
    }
    // console.log(tableData["payload"]["sidecut"]["values"])
    this.kpiParentIdStr = tableData.parent_id?tableData.parent_id:"";
    // "parent_id":tableData.parent_id?tableData.parent_id:"",
    let currentTable = {
      "name":"",
      "topcutValue":tableData["payload"]["topcut"]["value_type"],
      "table_name":tableData["tableName"],
      "sidecutValue":tableData["payload"]["sidecut"]["value_type"],
      "tablecutValue":tableData["payload"]["values"]["value_type"],
      "topcut":[],
      "sidecut":[],
      "tablecut":[],
      "custom_options":[],
    }
    this.toplineService.is_header = tableData['is_header'];
    // let selectedSidecutIds = [];
    let topcut = tableData["payload"]["topcut"]["values"];
    let sidecut =  tableData["payload"]["sidecut"]["values"];
    // let sidecut =  tableData["data"]["options"]["rows"];
    let values =  tableData["payload"]["values"]["values"];
    this.editTableName = tableData["tableName"];

    if(tableData['payload']['merge'] && tableData['payload']['merge'].length){
        currentTable['merge'] = tableData['payload']['merge'];
    }
    Object.keys(sidecut).forEach(sCut => {
      sidecut[sCut]["selectionOrder"] = sidecut[sCut]["priority"]
      currentTable["sidecut"].push(sidecut[sCut]);
      // selectedSidecutIds.push(sidecut[sCut]["id"]);
    });

    if(tableData['payload']['custom_options'] && tableData['payload']['custom_options'].length){
      currentTable['custom_options'] = tableData['payload']['custom_options'];
      // tableData['payload']['custom_options'].forEach(custom_option => {
      //   let coStatus = false;
      //   custom_option["options"].forEach(cOption => {
          
      //   });
      // });
    }
    // let sidecutArrayForPriority = JSON.parse(JSON.stringify(currentTable["sidecut"]));
    // console.log("currentTable[sidecut] ===> ",currentTable["sidecut"])

    if (currentTable["topcutValue"] == "topcut") {
      this.topcutTreeArray = [];
      this.convertTopcutsToJSON(topcut);
      currentTable["topcut"] = this.topcutTreeArray
    }else{
      Object.keys(topcut).forEach(tCut => {
        currentTable["topcut"].push(topcut[tCut])
      });
    }
    if (currentTable["tablecutValue"] == "topcut") {
      this.topcutTreeArray = [];
      this.convertTopcutsToJSON(values);
      currentTable["tablecut"] = this.topcutTreeArray
    }else{
      Object.keys(values).forEach(taCut => {
        currentTable["tablecut"].push(values[taCut])
      });
    }
    // if(currentTable['custom_options']){

    // }

    this.toplineService.editTable(currentTable,tableData.table_id)
    // this.toplineService.editTable(currentTable,sidecutArrayForPriority,tableData.table_id)
  }
  resetDatatableToplineUtilities(){
    this.editTableName = "";
    this.topcutTreeArray = [];
    this.toplineService.currentTable = {};
    this.toplineService.currentTableJson = {};
    this.toplineService.table_id = "";
    this.kpiParentIdStr = "";
    this.toplineService.is_header = false;
    this.removekpiViewerMerge();
  }
  putTableInPayload(){
    let body = {"payload":{},"cross_tab_id":this.toplineService.crosstab_fileUUID,"file_id":this.toplineService.excelviewer_fileUUID,"parent_id":this.kpiParentIdStr};
    // if (this.selectedSheet.key) {
    //   body["sheet_name"] = this.selectedSheet.key;
    // }
    if (this.selectedSheet.value && this.selectedSheet.value.sheet_name) {
        body["sheet_name"] = this.selectedSheet.value.sheet_name;
      }
    if (this.selectedSheet.value.sheet_id) {
      body["sheet_id"] = this.selectedSheet.value.sheet_id;
    }
    body["payload"] = this.toplineService.currentTableJson;
    body['is_header'] = this.toplineService.is_header;
    // console.log("body is =====> ",body);
    // console.log("this.selectedSheet is =====> ",this.selectedSheet);
    // console.log(JSON.parse(body['payload']));
    if (this.toplineService.table_id && this.toplineService.table_id !="") {
      this.showEditedTable(body);
    }else{
      this.showCreatedTable(body)
    }
  }
  showCreatedTable(body){
    // body["priority"] = Object.keys(this.selectedSheet['value']['kpis']).length + 1;
    if (this.lastKpi && this.lastKpi.priority != null && this.lastKpi.priority >= 0) {
      body['priority'] = this.lastKpi.priority + 1;
    }else if(this.lastKpi == null){
      body['priority'] = 0;
    }
    // console.log("this.lastKpi is ===> ",this.lastKpi)
    // console.log("this.selectedSheet is ===> ",this.selectedSheet)
    // console.log("body for create table is ===> ",body)
    this.isLoading = true;
    this.repoService.createTopline(body).subscribe(
      result =>{
        if (result["status"] == 1) {
          this.notifier.notify("success","Table created successfully");
          this.toplineService.closeToplineParameter();
          this.resetDatatableToplineUtilities();
          if (Number(result["id"])) {
            this.setCurrentTableId(Number(result["id"]))
          }else{
            this.setCurrentTableId(null)
          }
          this.refreshFilterOptions(result['sheet_id']);
          this.isLoading = false;
        }else{
          this.notifier.notify("error","Something went wrong!");
          this.isLoading = false;
        }
      }, error =>{
        console.log(error);
        this.isLoading = false;
      }
    )
  }
  showEditedTable(body){
    // console.log("body for edit table is ===> ",body)
    this.isLoading = true;
    this.repoService.editTopline(body).subscribe(
      result =>{
        if (result["status"] == 1) {
          this.notifier.notify("success","Table edited successfully");
          this.toplineService.closeToplineParameter();
          this.resetDatatableToplineUtilities();
          // this.setCurrentTableId(result["id"])
          if (Number(result["id"])) {
            this.setCurrentTableId(Number(result["id"]))
          }else{
            this.setCurrentTableId(null)
          }
          let parent_id = result["parent_id"];
          this.kpiParentId = parent_id.split("$_$-$_$");
          // console.log(this.kpiParentId,'KpiParenId');
          this.refreshFilterOptions(result['sheet_id']);
          this.isLoading = false;
        }else{
          this.notifier.notify("error","Something went wrong!");
          this.isLoading = false;
        }
      }, error =>{
        console.log(error);
        this.isLoading = false;
      }
    )
  }
  convertTopcutsToJSON(topcutObj){
    Object.keys(topcutObj).forEach(key =>{
        if (topcutObj[key]["type"]=="topcut") {
          this.convertTopcutsToJSON(topcutObj[key]["options"])
        }else{
          this.topcutTreeArray.push(topcutObj[key])
        }
    })
  }
  copySheet(){
    this.closeAllTabs();
    if (this.selectedSheet.value.sheet_id) {
      let body = {"table_id":this.selectedSheet.value.sheet_id}
      this.isLoading = true;
      this.repoService.copySheet(body).subscribe(
        result=>{
          if (result["status"] == 1) {
            this.notifier.notify("success","Sheet copied successfully");
            this.refreshFilterOptions(result["id"]);
            this.isLoading = false;
          }else{
            this.notifier.notify("error","Something went wrong!")
            this.isLoading = false;
          }
        }, error =>{
          console.log(error)
          this.isLoading = false;
        }
      )
    }else{
      this.notifier.notify("error","Sheet not yet created!")
    }
  }

  renameSheet(){
    let isDuplicateSheetName = false;
    let body = {"id":this.selectedSheet.value.sheet_id, "name":this.selectedSheet.value.new_sheet_name};
    if (!this.selectedSheet.value.sheet_id) {
      this.selectedSheet.key= this.selectedSheet.value.name
      this.isSheetnameEdit = false
      return
    }
    Object.keys(this.allFilters).forEach(sheetKey => {
        if (this.allFilters[sheetKey]['sheet_name'] === this.selectedSheet.value.new_sheet_name) {
            isDuplicateSheetName = true;
        }
    });
    // if (Object.keys(this.allFilters).includes(this.selectedSheet.value.new_sheet_name)) {
    if (isDuplicateSheetName) {
      this.notifier.notify("error","Sheet name already exist!");
      this.isSheetnameEdit = true;
      return;
    }
    this.isLoading = true;
    this.repoService.editSheetName(body).subscribe(
      result=>{
        if (result["status"] == 1) {
          this.notifier.notify("success","Sheet name updated successfully");
          this.selectedSheet.key = result["result"]["name"]
          this.refreshFilterOptions(result["result"]["id"]);
          this.isSheetnameEdit = false;
          this.selectedSheetName ='';
          this.isLoading = false;
        }else{
          this.notifier.notify("error","Something went wrong!")
          this.isSheetnameEdit = true;
          this.isLoading = false;
        }
      }, error =>{
        console.log(error);
        this.isSheetnameEdit = true;
        this.isLoading = false;
      }
    )
  }

  parseSelectedSheetTopcuts(){
    this.currentSheetTopcuts = [];
    if (this.selectedSheet.value["payload"] && this.selectedSheet.value["payload"]["topcut"]) {
      let topCut = {"topcut":[],"value_type":this.selectedSheet.value["payload"]["topcut"]["value_type"],"selected_tables":this.selectedSheet.value["payload"]["selected_tables"]}
      if (this.selectedSheet.value["payload"]["topcut"]["value_type"] == "topcut") {
        this.topcutTreeArray = [];
        this.convertTopcutsToJSON(this.selectedSheet.value["payload"]["topcut"]["values"]);
        topCut["topcut"] = this.topcutTreeArray
      }else{
        Object.keys(this.selectedSheet.value["payload"]["topcut"]["values"]).forEach(tCut => {
          topCut["topcut"].push(this.selectedSheet.value["payload"]["topcut"]["values"][tCut])
        });
      }
      this.currentSheetTopcuts.push(topCut)
      // console.log("currentSheetTopcuts =====>",this.currentSheetTopcuts)
    }else{
      this.currentSheetTopcuts = [{"topcut":[],"value_type":"topcut","selected_tables":[]}]
    }
  }

  editSheetTopCut(topcut){
    let body = {
      sheet_id:this.selectedSheet.value.sheet_id,
      topcut:topcut,
      data_table_file_id:this.toplineService.crosstab_fileUUID,
      excel_viewer_file_id:this.toplineService.excelviewer_fileUUID
    };
    this.isLoading = true;
    this.repoService.editSheetName(body).subscribe(
      result=>{
        if (result["status"] == 1) {
          // this.notifier.notify("success","Sheet copied successfully");
          // this.refreshFilterOptions();
          this.isLoading = false;
        }else{
          this.notifier.notify("error","Something went wrong!");
          this.isLoading = false;
        }
      }, error =>{
        console.log(error);
        this.isLoading = false;
      }
    )
  }

  addToTableDefinition(uuid,cutType){
    let hasDublicate = "";
    hasDublicate = this.table_definition[cutType].find(def_uuid => { return def_uuid === uuid});
    if (!hasDublicate || hasDublicate ==="") {
      this.table_definition[cutType].push(uuid)
    }
  }

  getTreeFormat(topcutJson,cutType,optionType?){
//   getTreeFormat(topcutJson,optionType?){
    let topcutTree = [];
    let selectedTopCuts = [{"options":topcutJson}]
    selectedTopCuts.forEach(top => {
     let topcutObj = {};
     topcutObj['id'] = this.findID(top.options);
     topcutObj['topcut'] = {};
     top.options.forEach( option => {
       let splitOption = option['parent'].split('---');
       let splitParentName = option['parentName'].split('---');
       if (option['sType'] && option['sType'] == "All") {
         // isAllTopcut = true;
       }else{
         if (option['name']) {
            splitParentName.push(option['name']);
          }
         if (option['uuid']) {
            splitOption.push(option['uuid']);
          }
         splitParentName.splice(0,1);
         splitOption.splice(0,1);
         let map = topcutObj['topcut'];
         for (let i = 0; i < splitOption.length; i++) {
           let item = splitOption[i];
           this.addToTableDefinition(item,cutType);
           map[item] = map[item] || {};
           if (Object.keys(map[item]).length > 0 || i < splitOption.length - 1) {
            //  map[item]['type'] = 'topcut';
             map[item]['name'] = splitParentName[i]
            if(optionType === 'level'){
                map[item]['type'] = 'level';
            }else{
                map[item]['type'] = 'topcut';
            }
            
            //  map[item]['parent'] = option['parent'];
           }else{
             map[item] = option;
             map[item]['type'] = 'option';
             map[item]['show'] = option.show;
            //  map[item]['parent'] = option['parent'];
             map[item]['index'] = option["dindex"];
           }
           map[item]['options'] = map[item]['options'] || {};
           map = map[item]['options'];
         }
       }
     });
     this.removeEmptyOptions(topcutObj['topcut']);
     topcutTree.push(topcutObj);
   });
    return topcutTree[0]["topcut"]
  }

  findID(options){
    let len = 0;
    let key = '';
    options.forEach( (option) => {
      const arr = option['parent'].split('---');
      if(arr.length > len){
        len = arr.length;
        key = arr[1];
      }
    });
    return options[0].id.split('-')[0];
  }
  removeEmptyOptions(topcutObj){
    Object.keys(topcutObj).forEach((key)=>{
          if(Object.keys(topcutObj[key]['options']).length == 0){
            delete topcutObj[key]['options'];
          }else{
            this.removeEmptyOptions(topcutObj[key]['options']);
          }
    })
  }
  closeEditSheetComponent(){
    this.isSheetEditComponent = false;
  }

  closeAllTabs(){
    this.closeEditSheetComponent();
    this.toplineService.closeToplineParameter()
  }

  openToplineGroupTable(){
    this.isToplineGroupTableComponent = true;
  }

  drop(kpiId ,event: CdkDragDrop<string[]>) {
    console.log("event",event)
    console.log("kpiId",kpiId)
    moveItemInArray(kpiId, event.previousIndex, event.currentIndex);
  }

  closeKPIReorder(){
    this.selectedKpiReorder = {};
    this.isKpiReorder = false;
  }
  openKPIReorder(){
    this.isKpiReorder = true;
  }

  removekpiViewerMerge(){
    this.kpiViewerMerge = [];
  }


  openKpiGridRowNameEditComponentDialog(event:any): void {
    this.selectedKpiDetails = this.selectedKpi; 
    this.kpiGridEditRowNameEventContainer = event;
    const newValue = event.newValue;
    const oldValue = event.oldValue;
    const dialogRef = this.dialog.open(KpiGridRowNameEditComponent, {
      data:{'newName':newValue,'realName':oldValue},
      height:'260px',
      width:'500px',
    });
  }


  openRemoveTopcutPopup(event,headerText,len){
    let sameLevelAlltopCutContainer = this.topCutLevelContainer['level_'+(len)];
    this.topcutRemoveType = 'single';
    const dialogRef = this.dialog.open(RemoveTopcutComponent, {
      data:{openPopupType:'removeTopcut','headerText':headerText,'sameLevelAlltopCutContainer':sameLevelAlltopCutContainer},
      height:'220px',
      width:'500px',
    });
  }


  openAddTopcutPopup(event,headerText,len){
    let sameLevelAlltopCutContainer = this.topCutLevelContainer['level_'+(len)];
    const dialogRef = this.dialog.open(RemoveTopcutComponent, {
      data:{openPopupType:'addTopcut','headerText':headerText,'sameLevelAlltopCutContainer':sameLevelAlltopCutContainer},
      height:'310px',
      width:'500px',
    });
  }


  closeRemoveTopcutPopup(){
    this.dialog.closeAll();
  }


  saveTopCutRemovePopup(data:any){
    if(data){
      if(this.topcutRemoveType == 'single'){
        let obj = data.sameLevelAlltopCutContainer.find((va:any) => va['name'] === data['headerText']);
        if(obj){
          obj['delete'] = true;
        }
      }else{
        data.sameLevelAlltopCutContainer.map((va:any) => va['delete'] = true);
      }
      setTimeout(() => {
        if(this.kpiGridComponent){
          this.kpiGridComponent.ngOnInit();
        }
      }, 100);
      // console.log(this.selectedSheet);
      this.dialog.closeAll();
    }
  }


  saveAddedColumnTopCut(){
    setTimeout(() => {
      if(this.kpiGridComponent){
        this.kpiGridComponent.ngOnInit();
      }
    }, 100);
    this.dialog.closeAll();
    // console.log(this.selectedFilter);
  }


  closeDialogKpiGridRowNameEdit(){
    this.selectedKpiDetails = this.selectedKpi; 
    if (Number(this.selectedKpiDetails["id"])) {
      this.setCurrentTableId(Number(this.selectedKpiDetails["id"]))
    }else{
      this.setCurrentTableId(null)
    }
    let data = this.selectedKpiDetails['data'];
    let key = Object.keys(data)[0];
    let parent_id = data[key]["parent_id"];
    this.kpiParentId = parent_id.split("$_$-$_$");
    this.refreshFilterOptions();
    this.dialog.closeAll();
  }


  initKpiDetails(kpi:any,tab){
    setTimeout(() =>{
      this.kpi = kpi;
      this.openKpiAgGridTab = tab;
      this.selectedKpi ={
        id:this.kpi['kpiDetails'].kpi.kpi_id,
        data:{}
      }
      this.kpiKey = this.kpi['kpiDetails']["parents"][this.kpi['kpiDetails']["parents"].length - 1];
      if (this.kpi['kpiDetails'].kpi.text) {
        delete this.kpi['kpiDetails'].kpi.text
      }
      if (this.kpi['kpiDetails'].kpi.payload) {
        delete this.kpi['kpiDetails'].kpi.payload
      }
      let obj = this.kpi['kpiDetails']["kpi"];
      if (obj.options.data) {
        delete obj.options.data
      }
      this.selectedKpi["data"][this.kpiKey] = this.kpi['kpiDetails']["kpi"];
      this.kpiRows = obj["options"]["rows"];
    },10)
  }



  onSubmit(type?,data?,editRowName?){
    let tableData = this.selectedSheet['value']['kpis'];
    for (let i = 0; i < this.kpi['kpiDetails']["parents"].length; i++) {
      if (i > 0) {
        tableData = tableData["options"][this.kpi['kpiDetails']["parents"][i]]
      }else{
        tableData = tableData[this.kpi['kpiDetails']["parents"][i]]
      }
    }
    tableData["options"]["rows"] = this.selectedKpi["data"][this.kpiKey]["options"]["rows"];
    this.kpiRows.forEach((item) => {
      item["priority"] = this.openKpiAgGridTab.data.findIndex(rItem => rItem.uuid === item.label) + 1;
      if(!tableData['is_merged']){
        if(item.custom){
          let custom_priority = tableData["payload"]['custom_options'].findIndex((va:any) => va.name == item.v);
          if(custom_priority >= 0){
            tableData["payload"]['custom_options'][custom_priority]['priority'] = item["priority"];
          }
        }else{
          tableData["payload"]["sidecut"]["values"][item.origin_label]["priority"] = item["priority"];
        }
      }
    })

    if((type  && data)  && (type == 'editRowName' || type == 'italic' || type == 'bold' || type == 'underline' || type == 'textColor' || type == 'backGroundColor')){
      let obj = tableData["options"]["rows"].find((rItem) => (rItem.origin_label === data.origin_label));
      if(obj){
        if(type === 'editRowName'){
          editRowName['oldName'] = obj['name'].split("original_")[1];
          editRowName['rowId'] = obj['origin_label'];
        }else{
          obj['style'] = data['style'];
        }
      }
      if(!tableData['is_merged']){
        if(data.custom){
          let custom_obj = tableData["payload"]['custom_options'].find((va:any) => va.origin_label == data.origin_label);
          if(custom_obj){
            if(type === 'editRowName'){
              editRowName['oldName'] = custom_obj['name'].split("original_")[1];
              editRowName['rowId'] = custom_obj['origin_label'];
            }else{
              custom_obj['style'] = data['style'];
              // tableData["payload"]['custom_options'][custom_index]['style'] = data['style'];
            }
          }
        }else{
          Object.keys(tableData['payload']['sidecut']['values']).forEach((va) =>{
            if(va === data.origin_label){
              if(type === 'editRowName'){
                // editRowName['oldName'] = tableData['payload']['sidecut']['values'][va]['name'].split("original_")[1];
                // editRowName['rowId'] = data.origin_label;
              }
              else{
                tableData['payload']['sidecut']['values'][va]['style'] = data['style'];
              }
            }
          })
        }
      }
    }
    this.selectedKpi["payload"] = tableData["payload"];
    // console.log("this.selectedKpi ===> ",this.selectedKpi)
    if(type === 'editRowName'){
      this.selectedKpi['editName'] = editRowName;
    }
    this.isLoading = true;
    // console.log(this.selectedKpi);
    this.repoService.setKpiRowPriority(this.selectedKpi).subscribe(
      result=>{
        if (result["status"] == 1) {
          if(type == 'editRowName'){
            this.afterKpiChange();
          }
          this.isLoading = false;
        }else{
          this.notifier.notify("error","Something went wrong!");
          this.isLoading = false;
        }
      }, error =>{
        console.log(error);
        this.isLoading = false;
      }
    )
  }



  // changeCurrentKpiRowName(){
  //   let editName = {};
  //   editName['type'] = this.applyChangeForEditRowName;
  //   // editName['oldName'] = this.kpiGridEditRowNameEventContainer.oldValue;
  //   editName['newName'] = this.kpiGridEditRowNameEventContainer.newValue;
  //   this.onSubmit('editRowName',this.kpiGridEditRowNameEventContainer.data,editName);
  //   this.dialog.closeAll();
  //   this.applyChangeForEditRowName = "onlyTable";
  // }


  changeCurrentKpiRowName(){
    let editName = {};
    editName['type'] = this.applyChangeForEditRowName;
    // editName['oldName'] = this.kpiGridEditRowNameEventContainer.oldValue;
    editName['newName'] = this.kpiGridEditRowNameEventContainer.newValue;
    this.onSubmit('editRowName',this.kpiGridEditRowNameEventContainer.data,editName);
    
  }


  afterKpiChange(){
    if(this.applyChangeForEditRowName == "everyWhere"){
      this.toplineService.viewCreateTopline(this.toplineService.fileDetails);
    }
    this.applyChangeForEditRowName = "onlyTable";
    this.selectedKpiDetails = this.selectedKpi; 
    if (Number(this.selectedKpiDetails["id"])) {
      this.setCurrentTableId(Number(this.selectedKpiDetails["id"]))
    }else{
      this.setCurrentTableId(null)
    }
    let data = this.selectedKpiDetails['data'];
    let key = Object.keys(data)[0];
    let parent_id = data[key]["parent_id"];
    this.kpiParentId = parent_id.split("$_$-$_$");
    this.refreshFilterOptions();
    this.dialog.closeAll();
  }


  setChildComponent(comp){
    this.kpiGridComponent = comp;
  }


//   checkforSameSheets(){
//     this.isMergeFileContainAllSheets = true;
//     let arr = this.allSheetsNameForMerge.map((v:any) => (v.toLowerCase()));
//     this.allSheetsName.forEach((va:any) =>{
//       if(!arr.includes(va.toLowerCase())){
//         this.isMergeFileContainAllSheets = false;
//       }
//     })
//   }





}
